import { set } from 'mobx';
import { IAccessRequestResponse } from '~/types/server.types';

import type { User } from '~/models/user.model';
import { AccountAccessAuthorization } from '~/models/account-access-request.model';

const PRO_USER_EXPIRATION_DAYS = 60;

export class ProAccountAccessAuthorization extends AccountAccessAuthorization {
    user: User;
    pro_user: User;
    pro_team_members_ids: string[];

    constructor(request: IAccessRequestResponse) {
        super(request);
        set(this, request);
    }

    get expirationDays() {
        return PRO_USER_EXPIRATION_DAYS;
    }
}
